import React, { useState, useEffect } from 'react';
import { createCheckout } from './api';
import './SpecialOfferPopup.css';

const DOUBLE_PACKAGES = [
  { id: 'starter_x2',  name: 'Starter',  credits: 600,   bonus: 0,     price: '$9.99',   oldCredits: 300 },
  { id: 'basic_x2',    name: 'Basic',    credits: 1200,   bonus: 360,   price: '$19.99',  oldCredits: 780 },
  { id: 'popular_x2',  name: 'Popular',  credits: 2400,   bonus: 1560,  price: '$39.99',  oldCredits: 1980,  badge: 'Most popular' },
  { id: 'pro_x2',      name: 'Pro',      credits: 5400,   bonus: 5400,  price: '$89.99',  oldCredits: 5400 },
  { id: 'vip_x2',      name: 'VIP',      credits: 12000,  bonus: 19200, price: '$199.99', oldCredits: 15600, badge: 'Best value' },
];

export default function SpecialOfferPopup({ onClose, onBought }) {
  const [timeLeft, setTimeLeft] = useState(5 * 60);
  const [closing, setClosing] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) { clearInterval(timer); return 0; }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const mins = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const secs = String(timeLeft % 60).padStart(2, '0');

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 400);
  };

  const handleBuy = async (pkgId) => {
    setLoadingId(pkgId);
    try {
      const pkg = DOUBLE_PACKAGES.find(p => p.id === pkgId);
      if (window.fbq) window.fbq('track', 'InitiateCheckout', { content_name: pkgId, currency: 'USD', value: pkg ? parseFloat(pkg.price.replace('$', '')) : 0 });
      const origin = window.location.origin;
      const res = await createCheckout(pkgId, `${origin}/?payment=success`, `${origin}/?payment=cancelled`);
      window.location.href = res.data.checkout_url;
    } catch (err) {
      alert(err.response?.data?.detail || 'Could not start checkout.');
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className={`so-overlay ${closing ? 'closing' : ''}`} onClick={(e) => e.target === e.currentTarget && handleClose()}>
      <div className={`so-modal ${closing ? 'closing' : ''}`}>

        {/* Header */}
        <div className="so-header">
          <div className="so-header-bg" />
          <div className="so-neon-left" />
          <div className="so-neon-right" />
          <button className="so-close" onClick={handleClose}>&#x2715;</button>
          <div className="so-header-content">
            <div className="so-fire">&#x1F525;</div>
            <h2 className="so-headline">SPECIAL OFFER</h2>
            <p className="so-subheadline">You don't want to miss this!</p>
          </div>
          <div className="so-timer-bar">
            <span className="so-timer-label">Offer expires in</span>
            <span className="so-hourglass">&#x23F3;</span>
            <div className="so-countdown-box">
              <span className="so-countdown">{mins}:{secs}</span>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="so-body">
          <div className="so-double-badge">2X CREDITS ON ALL PACKAGES</div>
          <p className="so-desc">Get <strong>double the credits</strong> at the same price. This deal disappears when the timer hits zero.</p>

          <div className="so-packages">
            {DOUBLE_PACKAGES.map(pkg => (
              <div key={pkg.id} className={`so-pkg ${pkg.badge ? 'featured' : ''}`}>
                {pkg.badge && <div className="so-pkg-badge">{pkg.badge}</div>}
                <div className="so-pkg-name">{pkg.name}</div>
                <div className="so-pkg-credits">{pkg.credits + pkg.bonus}</div>
                <div className="so-pkg-old">
                  <span className="so-pkg-old-val">{pkg.oldCredits}</span>
                </div>
                <div className="so-pkg-label">
                  credits
                  {pkg.bonus > 0 && <span className="so-pkg-bonus">{pkg.bonus} bonus</span>}
                </div>
                <div className="so-pkg-price">{pkg.price}</div>
                <button
                  className="so-buy-btn"
                  onClick={() => handleBuy(pkg.id)}
                  disabled={loadingId === pkg.id || timeLeft === 0}
                >
                  {loadingId === pkg.id ? 'Redirecting...' : 'Grab Deal'}
                </button>
              </div>
            ))}
          </div>

          <button className="so-skip" onClick={handleClose}>No thanks, I'll pass</button>
        </div>
      </div>
    </div>
  );
}
